import React from "react";
import { Anchor, Button } from "../components";
import PostContent from "./PostContent";

export function Card({ node }) {
  const {
    databaseId = 0,
    uri,
    title,
    date,
    excerpt,
    content,
    featuredImage,
  } = node;
  const body = excerpt || content;

  const src = featuredImage?.node?.src;
  const alt = featuredImage?.node?.altText;

  return (
    <article className={`post-${databaseId} b--near-white bb pb4 mv4`}>
      <div className="flex-l">
        {src && (
          <div className="pr3 w5">
            <div className="aspect-ratio aspect-ratio--1x1">
              <img
                className="aspect-ratio--object object-cover"
                {...{ src, alt }}
              />
            </div>
          </div>
        )}

        <div className="flex-auto pr3">
          <h2 className="mt0">
            <Anchor href={uri} className="primary no-underline">
              {title}
            </Anchor>

            {date && (
              <div className="flex items-center mt2 f6 mt0-ns mid-gray">
                <div>{date}</div>
              </div>
            )}
          </h2>

          <PostContent trim className="mv4">
            {body}
          </PostContent>
        </div>

        <div className="tc tr-ns flex-none self-center">
          <Button to={uri}>Read More</Button>
        </div>
      </div>
    </article>
  );
}

export default Card;
